var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coloredProduct.saleCountdownText)?_c('div',{staticClass:"product-sale-countdown"},[_c('i',{staticClass:"product-countdown-icon-lightning"}),_vm._v(" "),_vm._v("\n    "+_vm._s(_vm.coloredProduct.saleCountdownText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }